import { IosArrowLeft } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const SlidePrevButton: Component = ({
  className,
}) => (
  <button
    aria-label="Prev slide"
    className={cx(
      styles.buttonIcon,
      className,
    )}
    type="button">
    <IosArrowLeft
      size={11} />
  </button>
);
